// extracted by mini-css-extract-plugin
export var addressFields = "_pd-0";
export var animationContainer = "_pd-1";
export var footer = "_pd-2";
export var lineItems = "_pd-3";
export var modalContent = "_pd-4";
export var orderName = "_pd-5";
export var strong = "_pd-6";
export var warning = "_pd-7";